import { mapState, mapGetters, mapActions } from 'vuex';

export default {
  computed: {
    ...mapState('cache', [
      'outgoingFriendshipRequestsId',
      'currentUserFriends',
      'incomingFriendshipRequests'
    ]),
    ...mapGetters('context', ['currentUserId'])
  },
  methods: {
    ...mapActions('cache', ['getFriendshipInfo']),
    async offerFriendship(userId) {
      await this.$http.get(`Relationship/OfferFriendship?receipientId=${userId}`);
      this.getFriendshipInfo();
      this.$hub.offerFriendship(userId);
      this.$hub.updateNotifications(userId);
    },
    async cancelFriendshipOffer(userId) {
      await this.$http.get(`Relationship/CancelFriendshipOffer?receipientId=${userId}`);
      this.getFriendshipInfo();
      this.$hub.updateFriends(userId);
    },
    async deleteFriend(userId) {
      await this.$http.get(`Relationship/DeleteFriend?friendId=${userId}`);
      this.getFriendshipInfo();
      this.$hub.updateFriends(userId);
    },
    async acceptFriendship(userId) {
      await this.$http.get(`Relationship/AcceptFriendship?userId=${userId}`);
      this.getFriendshipInfo();
      this.$hub.acceptFriendship(userId);
      this.$hub.updateNotifications(userId);
    },
    async denyFriendship(userId) {
      await this.$http.get(`Relationship/DenyFriendship?userId=${userId}`);
      this.getFriendshipInfo();
      this.$hub.updateFriends(userId);
    },
    isOfferedFriendship(userId) {
      return this.outgoingFriendshipRequestsId.some(x => x === userId);
    },
    isFriend(userId) {
      return this.currentUserFriends.some(x => x.id === userId);
    },
    isFriendshipRequested(userId) {
      return this.incomingFriendshipRequests.some(x => x.id === userId);
    },
    getCommonFriends(user) {
      if (user.id === this.currentUserId) return [];
      return user.friends.filter(x => this.currentUserFriends.map(f => f.id).includes(x.id));
    },
    getCommonFriendsCount(user) {
      const count = this.getCommonFriends(user).length;
      if (count === 0) return '';

      const countString = count.toString();
      const lastTwo = parseInt(countString.slice(-2), 10);
      let word = '';
      if (lastTwo > 10 && lastTwo < 15) {
        word = 'общих друзей';
      } else {
        const lastOne = parseInt(countString.slice(-1), 10);
        switch (lastOne) {
          case 1:
            word = 'общий друг';
            break;
          case 2:
          case 3:
          case 4:
            word = 'общих друга';
            break;
          default:
            word = 'общих друзей';
            break;
        }
      }
      return `${count} ${word}`;
    }
  }
};
